import { createGtm } from "@gtm-support/vue-gtm";

const gtm = createGtm({
  id: process.env.VUE_APP_GTM_ID,
  nonce: process.env.VUE_APP_GTM_NONCE,
  enabled: process.env.NODE_ENV === "production" && process.env.VUE_APP_GTM_ID,
});

export default gtm;
